export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CHATGPT: 'chatgpt',
  // KANBAN0725
  KANBAN: 'kanban',
  // KANBAN0725
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  WAVOIP: 'wavoip',
  GOOGLE_CALENDAR: 'google_calendar',
  // @tickets_cases — Gestor de Tickets
  CASE_MANAGEMENT: 'case_management',
  // @tickets_cases — Clase de caso Comercial (oportunidades)
  CASE_COMMERCIAL: 'case_commercial',
  CASE_WORK_ORDER: 'case_work_order', // Plan-Clase-Orden-de-Trabajo F1
  CASE_PROJECT: 'case_project', // Plan-Clase-Proyecto P1
  // @query_databases — Conexión ERP dentro de Base de Conocimiento
  ERP_CONNECTION: 'erp_connection',
  WHATSAPP_CALLS: 'whatsapp_calls', // diag/llamadas_whatsapp
  // @waba_templates — Gestión de plantillas de WhatsApp desde Configuración
  WHATSAPP_TEMPLATES: 'whatsapp_templates',
  // @knowledge_sources — Tab de Configuración dentro de Base de Conocimiento
  KNOWLEDGE_BASE_CONFIG: 'knowledge_base_config',
};
